import { Backdrop, Box } from '@mui/material';
import { QButton, QCard, QTypography } from '@kw/quokka-ui';

export const StaleOverlay = ({ onReload }: { onReload: () => void }) => {
  return (
    <Backdrop
      open
      sx={{
        zIndex: 999999,
        color: '#000',
        backdropFilter: 'blur(2px)',
        backgroundColor: 'rgba(0,0,0,0.55)',
        p: 3,
      }}
    >
      <QCard variant="outlined" sx={{ width: '100%', maxWidth: 560, p: 3, borderRadius: 2, boxShadow: 6 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <QTypography variant="h4Medium" component="h2">
            This tab is no longer active
          </QTypography>
          <QTypography variant="bodyRegular">
            You signed in from another tab. For safety, this tab is locked to prevent using an outdated session.
          </QTypography>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
            <QButton variant="contained" color="primary" onClick={onReload}>
              Reload
            </QButton>
          </Box>
          <QTypography variant="caption" color="text.secondary">
            Tip: If you keep seeing this, close extra tabs and keep only one active session.
          </QTypography>
        </Box>
      </QCard>
    </Backdrop>
  );
};
